import React from 'react'
import * as S from './SelectorAddress.styled'
import { useShipment } from '@entities/shipment/model'
import { useToggleAddressSelector } from 'src/features/shipment-selector/hooks'

const SelectorAddress = () => {
    const toggleAddressSelector = useToggleAddressSelector()
    const shipment = useShipment()
    return (
        <S.Container>
            <S.IconContainer>
                <S.Image />
            </S.IconContainer>
            <S.ShipmentContainer>
                <S.ShipmentSelectorBlock data-address-selector onClick={toggleAddressSelector}>
                    <S.ShipmentTitle>Адрес доставки</S.ShipmentTitle>
                    <S.ShipmentContent>
                        {shipment.shipAddressTitle ? (
                            <S.SeclectedShipmentTextButton data-address-selected={shipment.shipAddressId}>
                                {shipment.shipAddressTitle}
                            </S.SeclectedShipmentTextButton>
                        ) : (
                            <S.SeclectedShipmentTextButton>Ничего не выбрано</S.SeclectedShipmentTextButton>
                        )}
                    </S.ShipmentContent>
                </S.ShipmentSelectorBlock>
            </S.ShipmentContainer>
        </S.Container>
    )
}

export default SelectorAddress
